import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppModeEnum} from "../enums/appMode.enum";
import {DiscoverTypeEnum} from "../enums/discoverType.enum";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {FacebookService} from "ng2-facebook-sdk";
import {AngularFireAuth} from "angularfire2/auth";
import {ChooseTypeEnum} from "../enums/chooseType.enum";

@Component({
  selector: 'app-controls',
  templateUrl: './app-controls.component.html',
  styleUrls: ['./app-controls.component.scss']
})
export class AppControlsComponent implements OnInit {

  public open: boolean = false;

  public appModeEnum = AppModeEnum;
  public chooseTypeEnum = ChooseTypeEnum;
  public discoverTypeEnum = DiscoverTypeEnum;

  private appModeFirstChange: boolean = true;
  public appModeValue: AppModeEnum;
  @Output() appModeChange: EventEmitter<AppModeEnum> = new EventEmitter();
  @Input()
  get appMode(): AppModeEnum {
    return this.appModeValue;
  }
  set appMode(val) {
    if(this.appModeValue !== val) {
      this.appModeValue = val;
      if (this.appModeFirstChange){
        this.appModeFirstChange = false;
      } else {
        this.appModeChange.emit(this.appModeValue);
      }
    }
  }

  private chooseTypeFirstChange: boolean = true;
  public chooseTypeValue: ChooseTypeEnum;
  @Output() chooseTypeChange: EventEmitter<ChooseTypeEnum> = new EventEmitter();
  @Input()
  get chooseType(): ChooseTypeEnum {
    return this.chooseTypeValue;
  }
  set chooseType(val) {
    if(this.chooseTypeValue !== val) {
      this.chooseTypeValue = val;
      if (this.chooseTypeFirstChange){
        this.chooseTypeFirstChange = false;
      } else {
        this.chooseTypeChange.emit(this.chooseTypeValue);
      }
    }
  }

  private discoverTypeFirstChange: boolean = true;
  public discoverTypeValue: DiscoverTypeEnum;
  @Output() discoverTypeChange: EventEmitter<DiscoverTypeEnum> = new EventEmitter();
  @Input()
  get discoverType(): DiscoverTypeEnum {
    return this.discoverTypeValue;
  }
  set discoverType(val) {
    if(this.discoverTypeValue !== val) {
      this.discoverTypeValue = val;
      if (this.discoverTypeFirstChange){
        this.discoverTypeFirstChange = false;
      } else {
        this.discoverTypeChange.emit(this.discoverTypeValue);
      }
    }
  }


  public radiusKmValue: number;
  @Output() radiusKmChange: EventEmitter<number> = new EventEmitter();
  @Input()
  get radiusKm(): number {
    return this.radiusKmValue;
  }
  set radiusKm(val) {
    if(this.radiusKmValue !== val) {
      this.radiusKmValue = val;
      this.radiusKmChange.emit(this.radiusKmValue);
    }
  }


  public approximationKmValue: number;
  @Output() approximationKmChange: EventEmitter<number> = new EventEmitter();
  @Input()
  get approximationKm():number {
    return this.approximationKmValue;
  }
  set approximationKm(val) {
    if(this.approximationKmValue !== val) {
      this.approximationKmValue = val;
      this.approximationKmChange.emit(this.approximationKmValue);
    }
  }


  public numberOfPointsValue;
  @Output() numberOfPointsChange: EventEmitter<number> = new EventEmitter();
  @Input()
  get numberOfPoints(): number {
    return this.numberOfPointsValue;
  }
  set numberOfPoints(val) {
    if(this.numberOfPointsValue !== val) {
      this.numberOfPointsValue = val;
      this.numberOfPointsChange.emit(this.numberOfPointsValue);
    }
  }

  @Output() generatePoints: EventEmitter<any> = new EventEmitter();
  @Output() toggleSidebar: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router, private translate: TranslateService, public afAuth: AngularFireAuth) { }

  ngOnInit() {
  }

  public generateNewPoints(){
    this.generatePoints.emit();
  }

  public toggleControls(state?){
    if(state){
      this.open = state;
    } else {
      this.open = !this.open;
    }
  }
  public logOut(){
    this.afAuth.auth.signOut();

    localStorage.clear();
    this.router.navigate([`/login`]);
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/app-controls/app-controls.component.ts